const locale = {
	ERROR403: 'Error 403',
	ERROR403TEXT: 'Wir dürfen Ihnen diese Seite nicht zeigen.',
	ERROR403SUBTEXT: 'Anscheinend haben Sie für diese Seite keine Berechtigung oder keine gültige Lizenz!',
	ERROR404: 'Fehler 404',
	ERROR404TEXT: 'Es tut uns leid, aber wir konnten diese Seite nicht finden!',
	BACKTOMAIN: 'Zurück zur Hauptseite',
	ERROR500: 'Fehler 500',
	ERROR500TEXT: 'Hoppla, etwas ist schiefgelaufen!',
	ERROR500SUBTEXT: 'Es sieht so aus als hätten wir ein internes Problem, bitte versuchen Sie es in ein paar Minuten wieder.',
	REPORTPROBLEM: 'Diesen Fehler melden'
};

export default locale;
